module.exports = __webpack_public_path__ + "assets/img/KeyReport_mudie.1065c574-ps.jpg";